import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { BillingOverview } from './BillingOverview.tsx';

class Billing extends Component {
  state = {
    appName: 'ShieldGPS',
  };

  render() {
    return (
      <div className="dashboard-settings">
        <Route
         exact
         path={this.props.match.path}
         component={BillingOverview}
        />
      </div>
    );
  }
}
export default Billing;
